import { useHistory } from "react-router-dom";
import { Form, Input, message, Button, Select } from "antd";
import { updateOne } from "../../api/user";
import { formLayout, ROLES_AVAILABLE } from "../../utils/constants";
import NewPassword from "./NewPassword";

const { Option } = Select;

function EditUser({ usuario, closeModal, setModalContent }) {
  const history = useHistory();

  const onFinish = (values) => {
    sendDataToServer(values);
  };

  // ------ Actualiza usuario ------
  const sendDataToServer = async (data) => {
    try {
      const response = await updateOne(data, usuario._id);
      message.success(response.message);
      history.replace("/app/usuarios");
      closeModal();
    } catch (err) {
      message.error(err.message);
    }
  };

  const onFinishFailed = ({ values }) => {
    if (Number(values.nrodocumento) < 1) {
      message.error("Número de DNI no válido");
    }
  };

  // ----- muestra componente para cambiar contraseña -----
  const showNewPassword = () => {
    setModalContent(
      <NewPassword userId={usuario._id} firstName={usuario.nombre} closeModal={closeModal} />
    );
  };

  return (
    <Form
      {...formLayout.formItemLayout}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Usuario"
        name="usuario"
        initialValue={usuario.usuario}
        rules={[
          {
            required: true,
            message: "El campo usuario es necesario"
          }
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Número de DNI"
        name="nrodocumento"
        initialValue={usuario.nrodocumento}
        rules={[
          {
            required: true,
            message: "El campo DNI es necesario"
          },
          {
            len: 8,
            message: "El valor debe tener 8 caracteres"
          }
        ]}
      >
        <Input type="number" />
      </Form.Item>

      <Form.Item
        label="Nombres"
        name="nombre"
        initialValue={usuario.nombre}
        rules={[{ required: true, message: "El nombre es necesario" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Apellidos"
        name="apellido"
        initialValue={usuario.apellido}
        rules={[{ required: true, message: "El apellido es necesario" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Rol"
        name="idrol"
        initialValue={usuario.idrol}
        rules={[{ required: true, message: "El rol es necesario" }]}
      >
        <Select>
          {ROLES_AVAILABLE.map((rol) => (
            <Option value={rol.idrol}>{rol.nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item {...formLayout.tailFormItemLayout}>
        <Button type="link" block onClick={showNewPassword}>
          Actualizar contraseña
        </Button>
      </Form.Item>

      <Form.Item {...formLayout.tailFormItemLayout}>
        <Button type="primary" block htmlType="submit">
          Actualizar usuario
        </Button>
      </Form.Item>
    </Form>
  );
}

export default EditUser;
